import React,{useState , useEffect} from 'react'
import { Link } from 'react-router-dom'


// import blog_1 from '../assets/images/blog_1.jpg';
// import par1 from '../assets/images/par1.jpg';
// import par2 from '../assets/images/par2.jpg';
// import par3 from '../assets/images/par3.jpg';
// import par4 from '../assets/images/par4.jpg';
// import par5 from '../assets/images/par5.jpg';
// import par6 from '../assets/images/par6.jpg';
// import back from '../assets/images/back.jpg';


// import b1 from '../assets/images/b1.jpg';
// import b2 from '../assets/images/b2.jpg';
// import b3 from '../assets/images/b3.jpg';
// import b4 from '../assets/images/b4.jpg';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";


const SubCategories = (props) => {

    const [Categories , setCategories] = useState([])
    const [Categories1 , setCategories1] = useState([])
    const [Homo , setHomo] = useState([])
    const [product , setproduct] = useState([])
    const [product1 , setproduct1] = useState([])
    const [UserDatat , setUserDatat] = useState({})
    const [userHeader , setuserHeader] = useState(false)
    const [SliderPhoto , setSliderPhoto] = useState([])
    const [ArrivalPhoto , setArrivalPhoto] = useState([])
    const [BannerPhoto , setBannerPhoto] = useState([])
    const [MainCatogories , setMainCatogories] = useState([])
    const [CategoriesName , setCategoriesname] = useState("")
    const [SubCategoriesName , setSubCategoriesname] = useState([])
    const [SubCategories , setSubCategories] = useState([])
    const [Heading , setHeading] = useState([])

    useEffect(() => {
        window.scrollTo(0, 0)

        const dar = setInterval(() => {
            let Categoriesname = props.history.location.pathname.split("/")[2] ;
            setCategoriesname(props.history.location.pathname.split("/")[2])
            console.log(123,props.history.location.pathname.split("/")[2],Categoriesname,props)
            let con = props.history.location.pathname.split("/")[2]
            console.log(con)
        // console.log(props.history.location.pathname.split("/")[2]);
        
        fetch("https://student1stop-backend-vercel.vercel.app/slider-photo",{
        method: "GET",
         headers :  {
         "Content-Type" : "application/json" , 
     } ,
    })
    .then(res=>res.json())
    .then(res1=>{
        // console.log(res1[0]);
        setSliderPhoto(res1)
    
    })
        fetch("https://student1stop-backend-vercel.vercel.app/createMainCateLine",{
        method: "GET",
         headers :  {
         "Content-Type" : "application/json" , 
     } ,
    })
    .then(res5=>res5.json())
    .then(res6=>{
        // console.log(res1[0]);
        const data = res6.filter((res56,i)=>{
            // console.log(res56.Product_Catagories , props.history.location.pathname.split("/")[2]);
            return res56.Product_Catagories === props.history.location.pathname.split("/")[2]
        })
        setHeading(data)
    
    })

    
    fetch("https://student1stop-backend-vercel.vercel.app/AllCategories",{
        method: "GET",
         headers :  {
         "Content-Type" : "application/json" , 
     } ,
    })
    .then(res2=>res2.json())
    .then(res3=>{
        // console.log(res3);
        const Data1 = res3.filter((res4,i)=>{
            if (res4.MainCategories === props.history.location.pathname.split("/")[2])
            return res4
        })
        setSubCategories(Data1)
        setuserHeader(true)
        // setSubCategoriesname(res3)
    
    }) 
        },1000);
        
       
    return () => {
        clearInterval(dar)
    }
    }, [])




    return (
        <div>
                {/* <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0"><Link to="/">Home</Link>  <span className="mx-2 mb-0">/</span> <strong className="text-black">{CategoriesName}</strong></div>
                        </div>
                    </div>
                </div>  */}
                {/* <section>
                    <div className="container-fuild">
                        <div className="col-xl-12 col-lg-12 col-md-12" style={{width : "100%", margin  : "0px",padding: "0px"}} >
                                        <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" data-interval="2000" auto-play="true">
                                        <ol class="carousel-indicators">
                                            <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                                            <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                                            <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                                            <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
                                        </ol>
                                            <div class="carousel-inner">
                                            {
                                                SliderPhoto.length > 0 && SliderPhoto.map((res,i)=>{
                                                        return (
                                                             <>
                                                            <div class="carousel-item active" >
                                                                <img class="d-block w-100" src={res.photo1} alt="First slide"  style={{height:"300px"}}/>
                                                            </div>
                                                       
                                                                <div class="carousel-item" >
                                                                    <img class="d-block w-100" src={res.photo2} alt="Second slide"  style={{height:"300px"}}/>
                                                                </div>
                                                                <div class="carousel-item" >
                                                                    <img class="d-block w-100" src={res.photo3} alt="Third slide"  style={{height:"300px"}}/>
                                                                </div>
                                                                <div class="carousel-item" >
                                                                    <img class="d-block w-100" src={res.photo4} alt="Fourth slide"  style={{height:"300px"}}/>
                                                                </div>
                                                            </>
                                                        )
                                                })
                                            }
                                              
                                            </div>
                                            <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span class="sr-only">Previous</span>
                                            </a>
                                            <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span class="sr-only">Next</span>
                                            </a>
                                        </div>
                        </div>
                    </div>
                </section> */}
                  {/* <div class="carousel-item active" >
                                                    <img class="d-block w-100" src={Ban1} alt="First slide"  style={{height:"300px"}}/>
                                                </div>
                                                <div class="carousel-item">
                                                    <img class="d-block w-100" src={Ban2} alt="Second slide"   style={{height:"300px"}}/>
                                                </div>
                                                <div class="carousel-item">
                                                    <img class="d-block w-100" src={Ban3} alt="Third slide"   style={{height:"300px"}}/>
                                                </div>
                                                <div class="carousel-item">
                                                    <img class="d-block w-100" src={blog_1} alt="Fourth slide"   style={{height:"300px"}}/>
                                                </div> */}


                {SubCategories.length === 0 && SliderPhoto.length === 0?
   <Loader
        type="Puff"
        color="#00BFFF"
        height={100}
        width={100}
        timeout={10000} //3 secs
        style={{position : "fixed",    left: "40%",top:"20%",zIndex: "9999"}}
      /> 
      :""
}

                <section>
                    <div className="container-fuild" style={{margin : "70px auto" , width : "93%"}}>
                            <div className="row justify-content-center">
                                <div className="col-12 text-center">
                                    <h2 style={{fontSize: "30px",color : "black"}}> <b>{Heading.length > 0 ? Heading[0].Main_Heading_Categories : ""}</b> </h2>
                                    {/* <br/> */}
                                    {/* <h4 style={{color : "black"}} > {Heading.length > 0 ?Heading[0].Sub_Heading_Categories : ""} </h4> */}
                                    <center>
                                        <p style={{width : "320px" , border : "0.5px solid grey" }}></p>
                                    </center>
                                </div> 
                                {
                                    SubCategories.map((res,i)=>{
                                        if(res.Course_Sub_Catagories){
                                        return (
                                            <div className="arrival1">
                                                <Link to={"/main-categories/"+CategoriesName+"/"+res.Course_Sub_Catagories}><img src={res.photo} alt="" className="arrival-Photo11"/></Link>
                                            </div>
                                        )
                                        }
                                        else{
                                        return (
                                            <div className="arrival1">
                                                <Link to={"/categories/"+CategoriesName+"/"+res.CategoriesName}><img src={res.photo} alt="" className="arrival-Photo11"/></Link>
                                            </div>
                                        )
                                        }
                                    })

                                } 
                                        {/* <div className="arrival1">
                                            <Link to="/categories/books"><img src={par1} alt="" className="arrival-Photo11"/></Link>
                                        </div>
                                        <div className="arrival1" >
                                            <Link to="/categories/shoes"><img src={par2} alt="" className="arrival-Photo11"/></Link>
                                        </div>
                                        <div className="arrival1" >
                                            <Link to="/categories/bags"><img src={par3} alt="" className="arrival-Photo11"/></Link>
                                        </div>
                                            
                                        <div className="arrival1">
                                            <img src={par4} alt="" className="arrival-Photo11"/>
                                        </div>
                                        <div className="arrival1" >
                                            <img src={par5} alt="" className="arrival-Photo11"/>
                                        </div>
                                        <div className="arrival1" >
                                        <Link to="/categories/uniform"><img src={u5} alt="" className="arrival-Photo11"/></Link>
                                        </div> */}
                            </div>
                               
                            </div>
                </section>

                {SubCategories.length === 0 && SliderPhoto.length === 0 && userHeader?
              
  <center>
  <span style={{margin:  "auto"}}>
   <h3 style={{fontSize: "30px",color : "black"}}>No Categories Found !</h3>
</span>
  </center> 
     :  "" 
}






                {/* <section>
                    <div className="container-fuild" style={{margin : "70px auto" , width : "93%"}}>
                            <div className="row justify-content-center">
                                <div className="col-12 text-center">
                                    <h2 style={{color : "black"}} > <b>{CategoriesName} for Boys & Girls</b> </h2>
                                    <br/>
                                    <h4 style={{color : "black"}} > Featured Brands </h4>
                                    <center>
                                        <p style={{width : "320px" , border : "0.5px solid grey" }}></p>
                                    </center>
                                </div> 
                                <div className="arrival1">
                                            <Link to="/categories/bags/product"><img src={b1} alt="" className="arrival-Photo11"/></Link>
                                        </div>
                                        <div className="arrival1" >
                                            <img src={b2} alt="" className="arrival-Photo11"/>
                                        </div>
                                        <div className="arrival1" >
                                            <img src={b3} alt="" className="arrival-Photo11"/>
                                        </div>
                                        <div className="arrival1">
                                            <img src={b4} alt="" className="arrival-Photo11"/>
                                        </div>
                            </div>
                                
                            </div>
                </section> */}





        <a href="https://www.webocreators.com/shopify-website-design-ecommerce-service">Shopify Website Design Ecommerce Service</a> <br/>
<a href="https://www.webocreators.com/facebook-ads-management-service">Facebook Ads Management Service</a> <br/>
<a href="https://www.webocreators.com/google-ads-management-service">Google Ads Management Service</a> <br/>
<a href="https://www.webocreators.com/google-business-profile-service">Google Business Profile Service</a> <br/>
<a href="https://www.webocreators.com/web-development-services">Web Development Services</a> <br/>
<a href="https://www.webocreators.com/graphic-designing-services">Graphic Designing Services</a> <br/>
<a href="https://www.webocreators.com/video-editing-animation-services">Video Editing Animation Services</a> <br/>
<a href="https://www.webocreators.com/social-media-management-services">Social Media Management Services</a> <br/>
<a href="https://www.webocreators.com/mobile-apps-development-services">Mobile Apps Development Services</a> <br/>
<a href="https://www.webocreators.com/ecommerce-web-app-services">Ecommerce Web App Services</a> <br/>
<a href="https://www.webocreators.com/search-engine-optimization-services">Search Engine Optimization Services</a> <br/>
<a href="https://www.webocreators.com/domain-hosting-services">Domain Hosting Services</a> <br/>
<a href="https://www.webocreators.com/brand-identity-design-services">Brand Identity Design Services</a> <br/>
<a href="https://www.webocreators.com/digital-marketing-services">Digital Marketing Services</a> <br/>
<a href="https://www.webocreators.com/ads-management">Ads Management</a> <br/>
<a href="https://www.webocreators.com/aeo-answer-engine-optimization">AEO Answer Engine Optimization</a> <br/>
<a href="https://www.webocreators.com/android-app-design">Android App Design</a> <br/>
<a href="https://www.webocreators.com/app-design">App Design</a> <br/>
<a href="https://www.webocreators.com/app-development">App Development</a> <br/>
<a href="https://www.webocreators.com/brochure-design">Brochure Design</a> <br/>
<a href="https://www.webocreators.com/business-card-design">Business Card Design</a> <br/>
<a href="https://www.webocreators.com/corporate-video-editing">Corporate Video Editing</a> <br/>
<a href="https://www.webocreators.com/custom-thumbnail-design">Custom Thumbnail Design</a> <br/>
<a href="https://www.webocreators.com/custom-website-design">Custom Website Design</a> <br/>
<a href="https://www.webocreators.com/ecommerce-website-mobile-apps">Ecommerce Website Mobile Apps</a> <br/>
<a href="https://www.webocreators.com/flyer-design">Flyer Design</a> <br/>
<a href="https://www.webocreators.com/suspended-google-business-profile-service">Suspended Google Business Profile Service</a> <br/>
<a href="https://www.webocreators.com/verify-gmb">Verify GMB</a> <br/>
<a href="https://www.webocreators.com/service-area-gmb-profile-verification">Service Area GMB Profile Verification</a> <br/>
<a href="https://www.webocreators.com/gmb-profile-creation">GMB Profile Creation</a> <br/>
<a href="https://www.webocreators.com/gmb-profile-optimization">GMB Profile Optimization</a> <br/>
<a href="https://www.webocreators.com/gmb-profile-verification">GMB Profile Verification</a> <br/>
<a href="https://www.webocreators.com/ios-iphone-app-design">iOS iPhone App Design</a> <br/>
<a href="https://www.webocreators.com/local-seo">Local SEO</a> <br/>
<a href="https://www.webocreators.com/logo-design">Logo Design</a> <br/>
<a href="https://www.webocreators.com/meta-ads">Meta Ads</a> <br/>
<a href="https://www.webocreators.com/off-page-seo">Off Page SEO</a> <br/>
<a href="https://www.webocreators.com/on-page-seo">On Page SEO</a> <br/>
<a href="https://www.webocreators.com/ppc-pay-per-click">PPC Pay Per Click</a> <br/>


<a href="https://www.webocreators.com/profile-setup-and-optimization">Profile Setup And Optimization</a> <br/>
<a href="https://www.webocreators.com/react-ecommerce-website">React Ecommerce Website</a> <br/>
<a href="https://www.webocreators.com/shopify-ecommerce-website">Shopify Ecommerce Website</a> <br/>
<a href="https://www.webocreators.com/shopify-website-design">Shopify Website Design</a> <br/>
<a href="https://www.webocreators.com/smm-social-media-management">SMM Social Media Management</a> <br/>
<a href="https://www.webocreators.com/smm-social-media-marketing">SMM Social Media Marketing</a> <br/>
<a href="https://www.webocreators.com/smo-social-media-optimization">SMO Social Media Optimization</a> <br/>
<a href="https://www.webocreators.com/social-media-account-management">Social Media Account Management</a> <br/>
<a href="https://www.webocreators.com/social-media-video-editing">Social Media Video Editing</a> <br/>
<a href="https://www.webocreators.com/technical-seo">Technical SEO</a> <br/>
<a href="https://www.webocreators.com/tiktok-ads">TikTok Ads</a> <br/>
<a href="https://www.webocreators.com/ui-ux-design">UI UX Design</a> <br/>
<a href="https://www.webocreators.com/website-design">Website Design</a> <br/>
<a href="https://www.webocreators.com/website-development">Website Development</a> <br/>
<a href="https://www.webocreators.com/wordpress-ecommerce-website">WordPress Ecommerce Website</a> <br/>
<a href="https://www.webocreators.com/wordpress-website-design">WordPress Website Design</a> <br/>
<a href="https://www.webocreators.com/dropshipping-ecommerce-store">Dropshipping Ecommerce Store</a> <br/>
<a href="https://www.webocreators.com/dropshipping-shopify-marketing">Dropshipping Shopify Marketing</a> <br/>
<a href="https://www.webocreators.com/dropshipping-store-design">Dropshipping Store Design</a> <br/>
<a href="https://www.webocreators.com/e-commerce-marketing">E-Commerce Marketing</a> <br/>
<a href="https://www.webocreators.com/google-maps-promotion">Google Maps Promotion</a> <br/>
<a href="https://www.webocreators.com/google-search-engine-marketing">Google Search Engine Marketing</a> <br/>
<a href="https://www.webocreators.com/instagram-marketing-ads">Instagram Marketing Ads</a> <br/>
<a href="https://www.webocreators.com/landing-page-design">Landing Page Design</a> <br/>
<a href="https://www.webocreators.com/linkedin-profile-optimization">LinkedIn Profile Optimization</a> <br/>
<a href="https://www.webocreators.com/logo-animation">Logo Animation</a> <br/>
<a href="https://www.webocreators.com/menu-design">Menu Design</a> <br/>
<a href="https://www.webocreators.com/packaging-label-design">Packaging Label Design</a> <br/>
<a href="https://www.webocreators.com/responsive-web-design">Responsive Web Design</a> <br/>
<a href="https://www.webocreators.com/search-engine-marketing">Search Engine Marketing</a> <br/>
<a href="https://www.webocreators.com/shopify-marketing">Shopify Marketing</a> <br/>
<a href="https://www.webocreators.com/signage-design">Signage Design</a> <br/>
<a href="https://www.webocreators.com/small-business-marketing-consultant">Small Business Marketing Consultant</a> <br/>



<a href="https://www.webocreators.com/small-business-website-design">Small Business Website Design</a> <br/>
<a href="https://www.webocreators.com/snapchat-ads">Snapchat Ads</a> <br/>
<a href="https://www.webocreators.com/social-media-design">Social Media Design</a> <br/>
<a href="https://www.webocreators.com/tax-consultant">Tax Consultant</a> <br/>
<a href="https://www.webocreators.com/web-developer">Web Developer</a> <br/>
<a href="https://www.webocreators.com/youtube-promotion">YouTube Promotion</a> <br/>
<a href="https://www.webocreators.com/amazon-advertising-agency">Amazon Advertising Agency</a> <br/>
<a href="https://www.webocreators.com/amazon-search-engine-optimization">Amazon Search Engine Optimization</a> <br/>
<a href="https://www.webocreators.com/chatbot-integration">Chatbot Integration</a> <br/>
<a href="https://www.webocreators.com/custom-cms-development">Custom CMS Development</a> <br/>
<a href="https://www.webocreators.com/erp-software-system">ERP Software System</a> <br/>
<a href="https://www.webocreators.com/etsy-store-setup">Etsy Store Setup</a> <br/>
<a href="https://www.webocreators.com/inventory-management-system">Inventory Management System</a> <br/>
<a href="https://www.webocreators.com/local-listings-management">Local Listings Management</a> <br/>
<a href="https://www.webocreators.com/marketplace-website-development">Marketplace Website Development</a> <br/>
<a href="https://www.webocreators.com/multi-vendor-ecommerce-development">Multi Vendor Ecommerce Development</a> <br/>
<a href="https://www.webocreators.com/payment-gateway-integration">Payment Gateway Integration</a> <br/>
<a href="https://www.webocreators.com/saas-software-development">SaaS Software Development</a> <br/>
<a href="https://www.webocreators.com/sales-page-design">Sales Page Design</a> <br/>
<a href="https://www.webocreators.com/software-quality-assurance">Software Quality Assurance</a> <br/>
<a href="https://www.webocreators.com/software-testing-service">Software Testing Service</a> <br/>
<a href="https://www.webocreators.com/subscription-based-ecommerce">Subscription Based Ecommerce</a> <br/>
<a href="https://www.webocreators.com/tax-filing-accounting-service">Tax Filing Accounting Service</a> <br/>
<a href="https://www.webocreators.com/tiktok-content-creation">TikTok Content Creation</a> <br/>
<a href="https://www.webocreators.com/ui-ux-redesign-service">UI UX Redesign Service</a> <br/>
<a href="https://www.webocreators.com/website-maintenance-support">Website Maintenance Support</a> <br/>
<a href="https://www.webocreators.com/woocommerce-website-design">WooCommerce Website Design</a> <br/>




<a href="https://gmbbusinessprofileservice.com/services/additional-google-business-appeal">Additional Google Business Appeal</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/citation-building-services">Citation Building Services</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-location-setup">Google Business Location Setup</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-photo-optimization">Google Business Photo Optimization</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-posts-management">Google Business Posts Management</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-appeal">Google Business Profile Appeal</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-consultation">Google Business Profile Consultation</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-creation">Google Business Profile Creation</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-management">Google Business Profile Management</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-optimization">Google Business Profile Optimization</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-reinstatement">Google Business Profile Reinstatement</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-verification">Google Business Profile Verification</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-maps-promotion">Google Maps Promotion</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-maps-ranking">Google Maps Ranking</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-maps-sponsored-ads">Google Maps Sponsored Ads</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-review-management">Google Review Management</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/local-seo-services">Local SEO Services</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/multi-location-seo">Multi Location SEO</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/service-area-business-verification">Service Area Business Verification</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/suspended-google-business-profile-recovery">Suspended Google Business Profile Recovery</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/affordable-local-seo">Affordable Local SEO</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gbp-profile-setup">GBP Profile Setup</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gmb-agency-near-me">GMB Agency Near Me</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gmb-audit">GMB Audit</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gmb-expert-near-me">GMB Expert Near Me</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gmb-listing-creation">GMB Listing Creation</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gmb-optimization-services-near-me">GMB Optimization Services Near Me</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gmb-review-service">GMB Review Service</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gmb-seo">GMB SEO</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/gmb-specialist-near-me">GMB Specialist Near Me</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-listing-creation">Google Business Listing Creation</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-listing-management">Google Business Listing Management</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-listing-optimization">Google Business Listing Optimization</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-listing-support">Google Business Listing Support</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-citations">Google Business Profile Citations</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-for-local-businesses">Google Business Profile For Local Businesses</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-for-online-businesses">Google Business Profile For Online Businesses</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-for-service-area-businesses">Google Business Profile For Service Area Businesses</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-listing-optimization">Google Business Profile Listing Optimization</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-multiple-locations">Google Business Profile Multiple Locations</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-ranking">Google Business Profile Ranking</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-recovery">Google Business Profile Recovery</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-seo">Google Business Profile SEO</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-service-area-business-optimization">Google Business Profile Service Area Business Optimization</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-suspended-help">Google Business Profile Suspended Help</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-verification-issues">Google Business Profile Verification Issues</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-suspension-appeal-not-approved">Google Business Suspension Appeal Not Approved</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-local-ranking">Google Local Ranking</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-maps-citations">Google Maps Citations</a> <br/>


<a href="https://gmbbusinessprofileservice.com/services/additional-google-business-appeal">additional-google-business-appeal</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/citation-building-services">citation-building-services</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-location-setup">google-business-location-setup</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-photo-optimization">google-business-photo-optimization</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-posts-management">google-business-posts-management</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-appeal">google-business-profile-appeal</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-consultation">google-business-profile-consultation</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-creation">google-business-profile-creation</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-management">google-business-profile-management</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-optimization">google-business-profile-optimization</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-reinstatement">google-business-profile-reinstatement</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-business-profile-verification">google-business-profile-verification</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-maps-promotion">google-maps-promotion</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-maps-ranking">google-maps-ranking</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-maps-sponsored-ads">google-maps-sponsored-ads</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/google-review-management">google-review-management</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/local-seo-services">local-seo-services</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/multi-location-seo">multi-location-seo</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/service-area-business-verification">service-area-business-verification</a> <br/>
<a href="https://gmbbusinessprofileservice.com/services/suspended-google-business-profile-recovery">suspended-google-business-profile-recovery</a> <br/>


<a href="https://urbanrepairksa.com">Urban Repair KSA Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/ac-service.html">AC Service Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/ac-repairing.html">AC Repair Service Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/ac-maintenance.html">AC Maintenance Service Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/ac-fitting.html">AC Fitting Service Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/ac-gas-filling.html">AC Gas Filling Service Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/electrician-services.html">Electrician Services Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/home-appliances-repair.html">Home Appliances Repair Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/fridge-freezer-service.html">Fridge Freezer Repair Service Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/washing-dryer-service.html">Washing Machine & Dryer Service Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/microwave-oven-repair.html">Microwave Oven Repair Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/led-tv-repair.html">LED TV Repair Service Riyadh</a> <br/>
<a href="https://urbanrepairksa.com/kitchen-stove-repair.html">Kitchen Stove Repair Service Riyadh</a> <br/>




<a href="https://urbanmoversksa.com">Urban Movers KSA - Professional Moving Services in Riyadh</a> <br/>

<a href="https://urbanmoversksa.com/about">About Urban Movers KSA Moving Company Riyadh</a> <br/>

<a href="https://urbanmoversksa.com/services">Furniture Moving and House Shifting Services in Riyadh</a> <br/>

<a href="https://urbanmoversksa.com/testimonials">Customer Reviews of Urban Movers KSA</a> <br/>

<a href="https://urbanmoversksa.com/contact">Contact Urban Movers KSA for Moving Services in Riyadh</a> <br/>




<a href="https://skycleancleaning.com">شركة سكاي كلين للتنظيف - خدمات تنظيف احترافية في الكويت</a> <br/>

<a href="https://skycleancleaning.com/من-نحن.html">من نحن - شركة سكاي كلين للتنظيف في الكويت</a> <br/>

<a href="https://skycleancleaning.com/خدماتنا.html">خدمات التنظيف للمنازل والشركات في الكويت</a> <br/>

<a href="https://skycleancleaning.com/اتصل-بنا.html">اتصل بشركة سكاي كلين للتنظيف في الكويت</a> <br/>

<a href="https://skycleancleaning.com/الأسعار.html">أسعار خدمات التنظيف في الكويت</a> <br/>

<a href="https://skycleancleaning.com/احجز-الآن.html">احجز خدمة تنظيف في الكويت الآن</a> <br/>

<a href="https://skycleancleaning.com/خدم-بالساعات-في-الكويت.html">خدمات خدم بالساعات في الكويت</a> <br/>

<a href="https://skycleancleaning.com/خدم-بالساعات-في-الكويت.html">عاملات تنظيف بالساعة في الكويت</a> <br/>

<a href="https://skycleancleaning.com/تنظيف-منازل-في-الكويت.html">تنظيف منازل في الكويت</a> <br/>

<a href="https://skycleancleaning.com/ارقام-خدم-بالساعات-حولي.html">أرقام خدم بالساعات في حولي</a> <br/>

<a href="https://skycleancleaning.com/خدم-بالساعات-الكويت-انستقرام.html">خدم بالساعات الكويت انستقرام</a> <br/>

<a href="https://skycleancleaning.com/شركة-تنظيف-الكويت.html">أفضل شركة تنظيف في الكويت</a> <br/>







<a href="https://tameerinternational.com">شركة تعمير الدولية للمقاولات والتركيب في الكويت</a> <br/>

<a href="https://tameerinternational.com/feature">مميزات شركة تعمير الدولية للخدمات</a> <br/>

<a href="https://tameerinternational.com/من-نحن.html">من نحن - شركة تعمير الدولية الكويت</a> <br/>

<a href="https://tameerinternational.com/feature.html">أفضل خدمات التركيب والتصميم في الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا.html">خدمات شركة تعمير الدولية للمقاولات</a> <br/>

<a href="https://tameerinternational.com/اتصل-بنا.html">تواصل مع شركة تعمير الدولية الكويت</a> <br/>

<a href="https://tameerinternational.com/آراء-العملاء.html">آراء عملاء شركة تعمير الدولية</a> <br/>

<a href="https://tameerinternational.com/نموذج-الحجز.html">احجز خدمات التركيب في الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تجديد-وتنجيد-الجلسات-الخارجية.html">تجديد وتنجيد الجلسات الخارجية في الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-أسوار-حديد-وخشب.html">تركيب أسوار حديد وخشب في الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-بوابات-حديد-حديثة.html">تركيب بوابات حديد حديثة الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-درابزين-حديد-للأسطح-والسلالم.html">تركيب درابزين حديد للأسطح والسلالم</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-ساندوتش-بانل-الكويت.html">تركيب ساندوتش بانل في الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-سواتر-حديدية.html">تركيب سواتر حديدية في الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-سواتر-خشبية-للأسطح-والمنازل.html">تركيب سواتر خشبية للمنازل والأسطح</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-مخازن-ساندوتش-بانل.html">تركيب مخازن ساندوتش بانل الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-مظلات-بولي-كربونيت-شفافة.html">تركيب مظلات بولي كربونيت شفافة</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-مظلات-حدائق-حديد-في-الكويت.html">تركيب مظلات حدائق حديد في الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-مظلات-حدائق-وسيارات.html">تركيب مظلات حدائق وسيارات</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-مظلات-سيارات-حديد-في-الكويت.html">تركيب مظلات سيارات حديد الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-مظلات-سيارات-متحركة-اوتوماتيكية-في-الكويت.html">تركيب مظلات سيارات متحركة أوتوماتيكية</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-مظلات-قماش-PVC.html">تركيب مظلات قماش PVC في الكويت</a> <br/>

<a href="https://tameerinternational.com/خدماتنا/تركيب-مظلات-كلادينج.html">تركيب مظلات كلادينج الكويت</a> <br/>




        </div>
    )
}

export default SubCategories ;
